














































import Vue from "vue";
import {mapActions} from 'vuex'
import DialogLayout from '@/components/forms/DialogLayout.vue'
import VeeTextField from '@/components/forms/VeeTextField.vue'


export interface Credentials {
  username: string;
  password: string;
}

export default Vue.extend({
  components: {
    VeeTextField,
    DialogLayout
  },
  data () {
    return {
      snackbar: false,
      activateDialog: false,
      credentials: {
        username: 'admin@example.com',
        password: 'passwordpassword'
      } as Credentials,
      error: '',
      text: ''
    }
  },
  props: {
    value: {
      required: true,
      type: Boolean
    }
  },
  created() {
    this.handleDialogLayout()
  },
  methods: {
    handleDialogLayout: function () {
      if (this.value) {
        this.activateDialog = true
      }
    },
    handleSubmit: async function (isValid) {
      if (isValid) {
        try {
          await this.logIn({
            email: this.credentials.username,
            password: this.credentials.password
          })
          this.$emit('relogin')
          this.activateDialog = false
        } catch (e) {
          this.snackbar = true
          this.text = 'Credenciales invalidas'
        }
      }
    },
    ...mapActions('auth', ['logIn'])
  },
  watch: {
    value: function() {
      this.handleDialogLayout()
    },
    activateDialog: function () {
      this.$emit('input', this.activateDialog)
    }
  }
})

